<template>
  <!--    <v-app>-->
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        persistent
        width="500"
    >

      <v-card>
        <v-card-title class="text-h5 text-white info lighten-2 header-color">
          <v-btn
              icon
              dark
              @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn> &nbsp;
          شارژ حساب {{wallet.username}}
        </v-card-title>

        <v-card-text>
          <v-row class="mt-3">
            <v-flex class="text-center">
              <p class="my-3 text-font"><b> موجودی : {{ $options.filters.rial(wallet.wallets[0].balance) }} </b></p>
            </v-flex>
          </v-row>
          <v-row class="p-4">

            <v-row>
              <v-flex>
                <price-input v-model="balance"></price-input>

                <!--              <priceInput></priceInput>-->
              </v-flex>
            </v-row>
            <v-row class="justify-content-center py-3 p-3">
              <v-flex xs12 sm12 md3 lg3 xl3 class="p-2" v-for="(cost, index) in costs">

                <v-btn @click="prices(cost)" class="charge btn-grads "
                       :id="cost" :data-price="cost*(10000)" :key="index">{{ cost }} هزارتومان
                </v-btn>
              </v-flex>
            </v-row>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="my-4 float-left">
            <v-btn class="btn-grad" :loading="loading" @click="accept">پرداخت</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!--    </v-app>-->
</template>

<script>
import priceInput from "@/view/pages/pickers/priceInput";

export default {
  name: "Wallet.vue",
  components: {priceInput},
  props: {dialog: Boolean, value: null, wallet:[]},
  data() {
    return {
      costs: [50, 200, 500, 900],
      loading: false,
      balance: '',
    }
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("input", this.dialog);
    },
    accept() {
      // this.value = false;
      this.dialog = false;
      this.loading = true;
      this.$emit("input", this.dialog);
    },
    prices(cost) {
      if (this.balance === '')
        this.balance = 0
      this.balance += cost * 1000;
    },
  }
}
</script>

<style scoped>

.btn-grads, .header-color {
  background-image: linear-gradient(to right, #3A1C71 0%, #D76D77 51%, #3A1C71 100%)
}

.text-font {
  font-size: 14px;
}

</style>
